import * as Yup from 'yup';

export const assignedToFormSchema = Yup.object().shape({
  assignedTo: Yup.object()
    .shape({
      userID: Yup.string()
        .nullable()
        .required('Assigned To is required')
        .test('not-zero', 'Assigned To is required', (value) => value !== '' && value !== '0'),
    })
    .required('Assigned To is required'),
});
